import {SalesPriceDataValue} from "../../../app/controls/Sales/definitions/SalesPriceDataValue";
import {DOM} from "./DOM";

export namespace Price {

    export class Config {

        public static readonly priceLoaderClassName = "priceLoader";
        public static readonly priceDataName = "price";
        public static readonly languageDataName = "language";
    }

    export class Initializer {

        private readonly language: string;

        constructor() {
            this.language = DOM.Parser.getDataByNameFromElement(Config.languageDataName, DOM.Parser.getBodyElement());
        }

        /**
         * Initialize prices to be uniform
         * Look to every element with priceLoader class
         * Parse price
         * Add price to DOM
         * @private
         */
        public initializePrices(container?: HTMLElement) : void {

            const loaders = DOM.Parser.getHtmlElements(Config.priceLoaderClassName, container, true);
            for (let i = 0; i < loaders.length; i++) {
                const loader = loaders[i];
                const price : SalesPriceDataValue = JSON.parse(DOM.Parser.getDataByNameFromElement(Config.priceDataName, loader));
                loader.innerText = this.getPriceAmountStringFromPriceObject(price, false, false);
            }
        }

        /**
         * Contains price interpretation function
         * Formats output price value as string
         * @param price - price data object
         * @param withoutCurrency - don't append currency symbol
         * @param changeMode - is change mode (use +/-)
         * @param showZero - show zero value if it is
         */
        public getPriceAmountStringFromPriceObject(price: SalesPriceDataValue, withoutCurrency: boolean, changeMode: boolean, showZero: boolean = false) : string {

            // Prepare price string
            let amountString = this.getAmountFormatter().format(price.price);

            // Change mode functionality
            if (changeMode) {
                amountString = price.price > 0
                    ? '+' + amountString
                    : (price.price === 0 && !showZero  ? '' : amountString);
            }

            // Produce output
            return withoutCurrency || (changeMode && price.price === 0) ? amountString : amountString + ' ' + price.currency;
        }

        /**
         * Get Intl formatter for amount numbers
         * @private
         */
        private getAmountFormatter() : Intl.NumberFormat {
            return new Intl.NumberFormat(this.language === 'cs' ? 'cs-CZ' : 'en-US', {
                minimumFractionDigits: 2
            });
        }

    }
}